import React from 'react';
import { observer } from 'mobx-react';

import { ComponentBase } from '../../../shared/ComponentBase.js';
import { InjectedStyledComponent } from '../../../shared/InjectedStyledComponent.js';

import { IProgressIndicatorConfiguration, IProgressIndicatorProps, IProgressIndicatorState } from './models/index.js';
import CompletedStep from './styledComponents/CompletedStep.js';
import UncompletedStep from './styledComponents/UncompletedStep.js';
import Wrapper from './styledComponents/Wrapper.js';
import { PROGRESS_INDICATOR_CATEGORY_KEY, PROGRESS_INDICATOR_COMPONENT_KEY } from './ProgressIndicator.meta.js';

export class ProgressIndicator extends ComponentBase<
	IProgressIndicatorProps,
	IProgressIndicatorState,
	IProgressIndicatorConfiguration
> {
	categoryKey = PROGRESS_INDICATOR_CATEGORY_KEY;
	componentKey = PROGRESS_INDICATOR_COMPONENT_KEY;

	constructor(props: IProgressIndicatorProps) {
		super(props);
	}
	render() {
		const { className, maxSteps, currentStep = 0, onClick } = this.props;

		const stepValues = Array.from(Array(maxSteps).keys());
		return (
			<Wrapper className={className}>
				{stepValues.map((stepValue) => {
					const StepComponent = stepValue < currentStep ? CompletedStep : UncompletedStep;
					return (
						<StepComponent
							key={`Step_${stepValue}`}
							onClick={() => {
								onClick && onClick(stepValue + 1);
							}}
						>
							{stepValue}
						</StepComponent>
					);
				})}
			</Wrapper>
		);
	}
}

export default InjectedStyledComponent(
	observer(ProgressIndicator),
	PROGRESS_INDICATOR_CATEGORY_KEY,
	PROGRESS_INDICATOR_COMPONENT_KEY,
);
